import React from 'react';
import { SeoHead } from './components/SeoHead';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AeoSummary } from './components/AeoSummary';
import { Results } from './components/Results';
import { ExposureSites } from './components/ExposureSites';
import { CaliforniaResources } from './components/CaliforniaResources';
import { Faq } from './components/Faq';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-50 flex flex-col font-sans selection:bg-brand-accent selection:text-brand-900" data-id="element-0" data-mp="2mn5f2tci77mi">
      <SeoHead data-id="element-1" data-mp="31ctd9lpe1q60" />
      <Header data-id="element-2" data-mp="2wk0a329kipw1" />

      <main className="flex-grow" data-id="element-3" data-mp="2wk9xqj754kyk">
        <Hero data-id="element-4" data-mp="2wj8f9tnsow6t" />
        <AeoSummary data-id="element-5" data-mp="2wip54z4dzc3c" />
        <Results data-id="element-6" data-mp="2wi5mfg6wwjo9" />
        <ExposureSites data-id="element-7" data-mp="28u5ysp4wd9dw" />
        <CaliforniaResources data-id="element-8" data-mp="28te21azkd5m1" />
        <Faq data-id="element-9" data-mp="28sl4n0mhvsgk" />
        <Contact data-id="element-10" data-mp="28s2xva27hvue" />
      </main>

      <Footer data-id="element-11" data-mp="23vunsb2v8su3" />
    </div>;
}